var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBilling(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 8,
    stroke: "#000",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m13.961 7.512-.804 1.404c-.48-.324-.996-.576-1.488-.708v1.824c1.824.492 2.604 1.224 2.604 2.568v.024c0 1.344-1.032 2.208-2.544 2.364v1.188h-1.248v-1.212a6.029 6.029 0 0 1-2.832-1.14l.936-1.368c.648.492 1.248.828 1.956.972V11.52c-1.728-.468-2.58-1.116-2.58-2.544v-.024c0-1.32 1.008-2.196 2.52-2.352v-.696h1.248v.732c.852.108 1.572.42 2.232.876Zm-1.44 5.184c0-.396-.204-.648-.852-.888v1.68c.564-.084.852-.336.852-.768v-.024ZM9.713 8.868c0 .384.168.624.828.864V8.1c-.588.072-.828.36-.828.744v.024Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBilling);
export default __webpack_public_path__ + "static/media/icon-billing.27c30f998c4ff5c991a83cffaff7b150.svg";
export { ForwardRef as ReactComponent };